import type { InvoicingView } from '../types/invoicingView'

export const invoicingViewTrackingLocationMap: Record<InvoicingView, string> = {
  invoiceEditor: 'Invoice Editor',
  invoiceList: 'Invoices List',
  invoiceView: 'Invoice View',
  quotesList: 'Quotes List',
}
